import { useEffect, useState } from "react";
import { Video, Lock, Globe2, Calendar } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function ConferencesPage() {
  const [confs, setConfs] = useState([]);
  const [active, setActive] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/conferences").then((r) => setConfs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="conferences-page">
      <section className="bg-ink text-white py-16 grain relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="eyebrow eyebrow-on-dark flex items-center gap-3"><Video className="w-4 h-4" /> Conférences en ligne</div>
          <h1 className="font-serif text-4xl lg:text-5xl mt-3 tracking-tight leading-tight">Salles de conférences intégrées</h1>
          <p className="mt-6 text-white/70 max-w-2xl">Conférences publiques diffusées sur la Web TV. Conférences privées réservées aux membres autorisés.</p>
        </div>
      </section>

      {active && (
        <section className="bg-black">
          <div className="max-w-7xl mx-auto">
            <div className="aspect-video">
              <iframe
                src={`https://meet.jit.si/${active.room_name}#config.prejoinPageEnabled=false&userInfo.displayName="${encodeURIComponent((user?.first_name||"") + " " + (user?.last_name||"") || "Invité")}"`}
                title={active.title}
                allow="camera; microphone; fullscreen; display-capture; autoplay"
                className="w-full h-full border-0"
                data-testid="jitsi-iframe"
              />
            </div>
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 text-white text-sm flex items-center justify-between">
              <div>{active.title}</div>
              <button onClick={() => setActive(null)} className="text-gold hover:underline" data-testid="leave-conference">Quitter la salle</button>
            </div>
          </div>
        </section>
      )}

      <section className="py-16 bg-bone">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 className="font-serif text-3xl text-ink leading-tight">À l'affiche</h2>
          {confs.length === 0 ? (
            <div className="mt-8 text-foreground/60">Aucune conférence programmée pour le moment.</div>
          ) : (
            <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {confs.map((c) => (
                <div key={c.id} className="bg-white border border-border rounded-sm p-6" data-testid={`conf-${c.id}`}>
                  <div className="flex items-center gap-2 text-xs">
                    {c.visibility === "public" ? <Globe2 className="w-4 h-4 text-gold-dark" /> : <Lock className="w-4 h-4 text-crimson" />}
                    <span className="eyebrow text-foreground/60">{c.visibility === "public" ? "Publique" : "Privée"}</span>
                  </div>
                  <h3 className="font-serif text-xl text-ink mt-2 leading-tight">{c.title}</h3>
                  <p className="mt-2 text-sm text-foreground/70">{c.description}</p>
                  <div className="mt-4 flex items-center gap-2 text-sm text-foreground/60">
                    <Calendar className="w-4 h-4" /> {new Date(c.scheduled_at).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" })}
                  </div>
                  <button onClick={() => setActive(c)} className="btn-primary mt-5 w-full justify-center text-sm" data-testid={`join-${c.id}`}>
                    Rejoindre la salle
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
